<template>
  <div class="search" v-if="this.$store.state.discount > 0">
    <div class="input-box">
      <div class="input">
        <input
          type="text"
          placeholder="请输入检测项目或相关名称"
          v-model="searchPageFrom.name"
          ref="inputFocus"
          @keyup="keyup"
        />
      </div>
      <div class="btn" @click="searchKeyWord">搜索</div>
    </div>
    <div v-if="!noSearchFlag">
      <div class="ProductList" v-if="productList.length > 0">
        <div
          class="item"
          v-for="(item, index) in productList"
          :key="index"
          @click="$goProductDetails(item.id, item.productId)"
        >
          <div class="left">
            <img src="../../assets/images/updataFile/ProductList-icon.png" />
          </div>
          <div class="right">
            <div class="right-top">
              <div class="product-name">{{ item.name }}</div>
              <div>
                <div
                  class="product-price"
                  style="text-decoration: line-through; color: #aaa"
                  v-if="$store.state.discount < 100"
                >
                  <span>￥</span>
                  <span>{{ item.salePrice }}</span>
                </div>

                <div class="product-price">
                  <span>￥</span>
                  <span>{{ calculationDiscount(item.salePrice) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noSearch" v-if="noSearchFlag">
      <div class="noSearchContent">
        <img src="../../assets/images/updataFile/noSearch-icon.png" />
        <div class="title">抱歉，没有找到相关项目结果</div>
        <div class="describe">请尝试搜索其他关键词</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noSearchFlag: false,
      productList: [],
      searchPageFrom: { name: "", current: 1, size: 10, productTypeId: "" },
      scrollLoadMoreFlag: true,
      total: 0,
    };
  },
  created() {
    // /product/searchPage   根据产品名称搜索
    window.addEventListener("scroll", this.scrollLoadMore);
    let query = this.$route.query;
    this.$set(this.searchPageFrom, "productTypeId", query.productTypeId);
    if (sessionStorage.getItem("searchPageFromName")) {
      this.$set(
        this.searchPageFrom,
        "name",
        sessionStorage.getItem("searchPageFromName")
      );
      this.searchKeyWord();
    }
  },
  methods: {
    keyup(e) {
      if (e.keyCode == 13) this.searchKeyWord();
    },
    /**
     * 根据产品名称搜索
     * @param {产品名称} name
     * @param {页码} current
     * @param {每页的个数} size
     */
    searchKeyWord() {
      let data = this.searchPageFrom;
      if (
        sessionStorage.getItem("searchPageFromName") &&
        sessionStorage.getItem("searchPageFromName") != data.name
      )
        data.current = 1;
      if (!data.name) this.$toots("请输入搜索文字");
      else {
        sessionStorage.setItem("searchPageFromName", data.name);
        this.$loading("搜索中");
        this.$http
          .get(`/product/searchPage`, {
            params: this.searchPageFrom,
          })
          .then((res) => {
            this.$store.state.loadingFlag = false;
            if (res.data.code == 200) {
              this.noSearchFlag = false;
              let data = res.data.data;
              this.productList = data.records;
              this.total = data.total;
              this.scrollLoadMoreFlag = true;
              if (data.records.length == 0) this.noSearchFlag = true;
            }
          })
          .catch((err) => {
            this.$toots("系统正在升级，请稍后");
          });
      }
    },

    /**
     * 滚动到底部加载更多
     */
    scrollLoadMore() {
      let size = this.searchPageFrom.current * this.searchPageFrom.size;
      if (this.scrollLoadMoreFlag && this.total > size) {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; // 兼容获取滚动条高度
        var scrollHeight = document.body.scrollHeight; // 获取整个document的高度
        var clientHeight = document.body.clientHeight; //获取当前显示的高度
        if (clientHeight + scrollTop + 30 > scrollHeight) {
          this.scrollLoadMoreFlag = false;
          this.searchPageFrom.current = this.searchPageFrom.current + 1;
          this.searchKeyWord();
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(function () {
        this.$refs.inputFocus.focus();
      });
    }, 500);
  },
};
</script>

<style lang='less' scoped>
.noSearch {
  width: 100%;
  height: 100%;
  .noSearchContent {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .title {
      font-size: 30px;
      font-weight: 700;
      margin-top: -20px;
    }
    .describe {
      color: #999999;
      font-size: 28px;
      margin-top: 15px;
    }
  }
  img {
    width: 374px;
    height: 288px;
    display: block;
    margin: 0 auto;
  }
}
.search {
  height: 100%;
  .input-box {
    background-color: #fff;
    padding: 40px 30px;
    display: flex;
    justify-content: space-between;
    .input {
      width: 600px;
      height: 70px;
      line-height: 70px;
      border-radius: 70px;
      background-color: #f8f8f8;
    }
    input {
      padding-left: 68px;
      width: 100%;
      font-size: 26px;
      background: url("../../assets/images/updataFile/search-icon2.png")
        no-repeat 30px center;
      background-size: 25px 28px;
    }
    input::placeholder {
      color: #aaa;
    }
    .btn {
      height: 70px;
      line-height: 70px;
      font-size: 30px;
    }
  }

  .ProductList {
    padding: 30px;
    padding-top: 20px;
    background-color: #f8f8f8;
    .item {
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;
      display: flex;
      justify-content: space-between;
      .left {
        position: relative;
        width: 80px;
        img {
          width: 50px;
          height: 70px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0px;
        }
      }
      .right {
        flex: 1;
        .right-top {
          display: flex;
          justify-content: space-between;
          padding-top: 50px;
          padding-bottom: 50px;
          position: relative;
          .product-name {
            font-size: 34px;
            padding-right: 30px;
          }
          .product-price {
            display: flex;
            align-items: center;
            color: #ef2538;
            font-weight: 700;
            span:first-child {
              font-size: 20px;
            }
            span:last-child {
              font-size: 34px;
            }
          }
        }
        .right-bottom {
          color: #888888;
          margin-top: 20px;
          line-height: 38px;
          text-align: justify;
        }
      }
    }
  }
}
</style>
